<template>
  <div class="soar-container flex gap-3 flex-col">
    <Form
      class="flex flex-col gap-y-2"
      @submit="(v) => $emit('onSearch', v)"
      v-if="!ticketAdded"
    >
      <CollapsibleSection :header-label="$t('applicantInformation')">
        <div class="flex flex-row flex-wrap">
          <Field name="applicantName" v-slot="{ field, errors: errs }">
            <SimpleTextInput
              :field="field"
              :errors="errs"
              :label="$t('applicantName')"
              :maxLength="100"
              direction="flex-col"
              :isRequired="true"
              class="flex-col px-2 w-full"
            />
          </Field>
          <Field name="email" v-slot="{ field, errors: errs }">
            <SimpleTextInput
              :field="field"
              :errors="errs"
              :label="$t('applicantEmail')"
              direction="flex-col"
              :isRequired="true"
              class="flex-col px-2 w-full"
              :isDisabled="true"
            />
          </Field>

          <Field
            v-if="countries.length"
            :rules="
              async (values) =>
                await checkRules(values, [
                  {
                    name: 'uae_mobile',
                    message: 'inValidLocalMobile'
                  }
                ])
            "
            name="mobileNumber"
            v-slot="{ field, errors: errs, handleChange }"
          >
            <ComboText
              :field="field"
              :errors="errs"
              :label="$t('applicantMobileNumber')"
              :options="countries"
              input-class="px-3 py-1.5"
              class="w-full md:w-1/2"
              direction="flex-col"
              defaultValue="00971"
              :prefixDisabled="true"
              @on-selection="(phone) => handleChange(phone)"
            ></ComboText>
          </Field>
          <Field name="requestNumber" v-slot="{ field, errors: errs }">
            <SimpleTextInput
              :field="field"
              :errors="errs"
              :label="$t('requestNumber')"
              direction="flex-col"
              class="flex-col px-2 w-full"
              :isDisabled="true"
            />
          </Field>

          <Field name="englishserviceNameDetails" v-slot="{ field, errors: errs }" class="w-full">
            <SimpleTextInput
              :field="field"
              :errors="errs"
              :label="$t('serviceName')"
              class="flex-col px-2 w-full"
              direction="flex-col"
              :isDisabled="true"
            />
          </Field>
        </div>
      </CollapsibleSection>
      <CollapsibleSection :header-label="$t('ticketInformation')">
        <div class="flex flex-row flex-wrap">
          <Field name="subject" v-slot="{ field, errors: errs }">
            <SimpleTextInput
              :field="field"
              :errors="errs"
              :label="$t('subject')"
              :maxLength="200"
              direction="flex-col"
              :isRequired="true"
              class="flex-col px-2 w-full"
            />
          </Field>

          <Field name="subApplicationId" v-slot="{ field, errors, handleChange }">
            <SimpleDropdown
              :field="field"
              :errors="errors"
              :label="$t('subApplications')"
              :options="serviceStatusList"
              :is-required="true"
              class="lg:w-1/2 flex-col px-2 w-full"
              @on-selection="(item) => handleChange(+item.id)"
            ></SimpleDropdown>
          </Field>

          <Field name="serviceId" v-slot="{ field, errors, handleChange }">
            <SimpleDropdown
              :field="field"
              :errors="errors"
              :label="$t('services')"
              :options="serviceStatusList"
              :is-required="true"
              class="lg:w-1/2 flex-col px-2 w-full"
              @on-selection="(item) => handleChange(+item.id)"
            ></SimpleDropdown>
          </Field>

          <Field name="details" v-slot="{ field, errors: errs }">
            <SimpleTextInput
              :field="field"
              :errors="errs"
              :label="$t('details')"
              :maxLength="200"
              direction="flex-col"
              :isRequired="true"
              class="flex-col px-2 w-full"
            />
          </Field>
        </div>
      </CollapsibleSection>
    </Form>
  </div>
</template>
<script setup>
import { ref, onBeforeMount } from 'vue'

import { Form, Field } from 'vee-validate'
import useRuleHandler from '@/composables/useRuleHandler'
import { useLookupsStore } from '@/stores/lookups'

import SimpleTextInput from '@/components/SimpleForm/TextInput.vue'
import ComboText from '@/components/SimpleForm/ComboText.vue'
import CollapsibleSection from '@/components/Ui/CollapsibleSection.vue'
import SimpleDropdown from '@/components/SimpleForm/Dropdown.vue'

const countries = ref([])
const subApplications = ref([])
const lookupsStore = useLookupsStore()

const checkRules = async (values, rules) => {
  const res = await useRuleHandler(values, rules)
  return res
}

onBeforeMount(async () => {
  countries.value = await lookupsStore.fetchLookup('/api/lookup/countries')
  subApplications.value = await lookupsStore.fetchLookup(
    '/api/ticketing/get-sub-applications-by-app-id'
  )
})
</script>
<style lang="scss" scoped></style>
